export const setupCarousels = () => {
	const carousels = document.querySelectorAll( '.carousel' );
	carousels.forEach( ( carousel, index ) => {
		if ( carousel.classList.contains( 'carousel--equal-height' ) ) {
			setupEqualHeightCarousel( carousel, index );
		}
		if ( carousel.querySelector( '.carousel-progress' ) ) {
			setupCarouselProgressBar( carousel, index );
		}
	} );
};

const setupEqualHeightCarousel = ( carousel, index ) => {
	let maxHeight = 0;
	const slides = carousel.querySelectorAll( '.carousel-item' );
	slides.forEach( ( slide ) => {
		slide.classList.add( 'd-block' );
		maxHeight = Math.max( maxHeight, slide.offsetHeight );
	} );
	slides.forEach( ( slide ) => {
		slide.classList.remove( 'd-block' );
		slide.style.minHeight = `${ maxHeight }px`;
	} );
};

const setupCarouselProgressBar = ( carousel, index ) => {
	const progressBar = carousel.querySelector( '.carousel-progress' );
	carousel.addEventListener( 'slide.bs.carousel', ( e ) => {
		progressBar.classList.remove( 'animated' );
	} );
	carousel.addEventListener( 'slid.bs.carousel', ( e ) => {
		progressBar.classList.add( 'animated' );
	} );
};
